module.exports = __webpack_public_path__ + "img/dna.e19e862a.gif";